import { makeVar } from "@apollo/client";

export enum NoteActionsheetState {
  List,
  Form,
}

export const noteActionsheetStateVar = makeVar<NoteActionsheetState>(
  NoteActionsheetState.List
);
